// extracted by mini-css-extract-plugin
module.exports = {"modal":"mui-modal_modal__351y6","paper":"mui-modal_paper__1I65z","header":"mui-modal_header__1qMn4","closeButton":"mui-modal_closeButton__gmVY-"};